<template>
  <div>
    <SysBtn class="ml-3" @click="dialog_ativo = ! dialog_ativo">
      <v-icon size="20">mdi-finance</v-icon>
      <span class="ml-1">Evolução estoque</span>
    </SysBtn>

    <SysDialogFullScreen v-model="dialog_ativo">
      <template #titulo>
        <div class="d-flex">
          <v-btn icon dark class="mr-4" @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <div class="d-flex align-center">
            <span class="font-20">Análise Macro</span>
            <span class="font-14 pt-1 pl-1" style="color: #fcfcfc">- Indicador da Evolução do Slow-no Moving (R$ custo)</span>
          </div>
        </div>
      </template>

      <Tabela class="mx-2" />
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from '../../../padraoDeLayout/SysDialogFullScreen.vue';
import Tabela from "./Tabela/Index.vue";

export default {
  name: "EvolucaoEstoqueParado",
  components: {
    SysDialogFullScreen,
    Tabela
  },
  data: () => ({
    dialog_ativo: false,
  })
}
</script>

